module.exports = __webpack_public_path__ + "img/fabric-slide-3-m.93519ed.webp";